
import "./style.css";

import { Questionario } from "./Sections/Questionario";
import { getTokenCadastro, setTokenCadastro } from "./Services/api";
import { Cadastro } from "./Sections/Cadastro";
import { useEffect, useRef, useState } from "react";
import { disciplinas } from "./params";

function Resultado({ resultado, setResultado }) {
    const { MEDIA_GERAL, ...resultados } = resultado;
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        ref.current.scrollIntoView({
            behavior: 'smooth', // 'auto' (default) or 'smooth'
            block: 'center',    // 'start', 'center', 'end', or 'nearest'
            inline: 'nearest'   // 'start', 'center', 'end', or 'nearest'
        });
    }, []);

    function handleVoltar(e) {
        e.preventDefault();
        setResultado(null);
    }

    return <div ref={ref}>
        <h3>Resultado</h3>

        <p>Média geral: {MEDIA_GERAL}</p>
        <ul>
            { Object.entries(resultados).map(([area, resultado]) => {
                return <li>{disciplinas[area]}: {resultado.nota}</li>
            })}
        </ul>

        <div className="correcao-tri-form-group">
            <button type="button" onClick={handleVoltar}>Voltar</button>
        </div>
    </div>
}

export function App() {
    const [token, setToken] = useState(() => {
        return getTokenCadastro();
    });

    const [resultado, setResultado] = useState(null);

    useEffect(() => {
        if (token) {
            setTokenCadastro(token);
        }
    }, [token]);

    function handleResultado(resultado) {
        setResultado(resultado);
    }

    if (!token) {
        return <Cadastro setToken={setToken} />;
    }

    if (resultado) {
        return <Resultado resultado={resultado} setResultado={setResultado} />;
    }

    return <Questionario setResultado={setResultado} />;
}
